<div class="ui-account-delete">
  <div class="ui-account-delete-content" mat-dialog-content>
    <div class="ui-account-delete-details">
      <object type="image/svg+xml" data="assets/images/icons/account-delete.svg"></object>
      <h3 class="ui-title">Solicitar baja de la cuenta</h3>
      <p>Estas a punto solicitar la baja de tu cuenta junto con todos tus servicios y productos asociados.</p>
    </div>

    <form class="ui-dialog" [formGroup]="formData">
      <div class="ui-form">
        <div class="ui-form-row">
          <mat-form-field class="ui-input">
            <mat-label>Teléfono de contacto</mat-label>
            <input matInput type="text" formControlName="phone">
            <mat-error *ngIf="formHasError('phone', 'validate')">{{formHasError('phone', 'message')}}</mat-error>
          </mat-form-field>
        </div>

        <div class="ui-form-row">
          <mat-form-field class="ui-input">
            <mat-label>E-Mail de contacto</mat-label>
            <input matInput type="text" formControlName="email">
            <mat-error *ngIf="formHasError('email', 'validate')">{{formHasError('email', 'message')}}</mat-error>
          </mat-form-field>
        </div>

        <div class="ui-form-row">
          <mat-form-field class="ui-input">
            <mat-label>Horario de contacto</mat-label>
            <input matInput type="text" formControlName="schedule">
            <mat-error *ngIf="formHasError('schedule', 'validate')">{{formHasError('schedule', 'message')}}</mat-error>
          </mat-form-field>
        </div>

        <div class="ui-form-row">
          <mat-checkbox color="primary" formControlName="contactByPhone">Contactar por teléfono</mat-checkbox>
        </div>

        <div class="ui-form-row">
          <mat-checkbox color="primary" formControlName="contactByEmail">Contactar por email</mat-checkbox>
        </div>

        <div class="ui-form-row">
          <mat-form-field class="ui-input">
            <mat-label>Motivo</mat-label>
            <mat-select formControlName="reason">
              <mat-option *ngFor="let item of reasonsData" [value]="item.id">{{item.name}}</mat-option>
            </mat-select>
            <mat-error *ngIf="formHasError('reason', 'validate')">{{formHasError('reason', 'message')}}</mat-error>
          </mat-form-field>
        </div>
        
        <div class="ui-form-row">
          <mat-form-field class="ui-input">
            <mat-label>Observaciones</mat-label>
            <textarea matInput type="text" formControlName="comment"></textarea>
            <mat-error *ngIf="formHasError('comment', 'validate')">{{formHasError('comment', 'message')}}</mat-error>
          </mat-form-field>
        </div>
      </div>
    </form>
  </div>

  <div class="ui-account-delete-actions" mat-dialog-actions>
    <button class="ui-button" mat-button (click)="onCancel()">Cancelar</button>
    <button class="ui-button" mat-button (click)="onSubmit()" color="primary" cdkFocusInitial>Solicitar baja</button>
  </div>
</div>